import {
  QuestionPracticeLearningResponse,
  DailyExaminationResponse,
  ErrorPronePracticeResponse,
  UpDownSettingsResponse,
  CourseLearningResponse,
  ExamLearningResponse
} from '@api/gateway/PreExamLS-default'
// import Effectiveness from '@api/model/myscheme/Effectiveness'
// 试题练习

export class PracticeLearningUi {
  /**
   * 练习学习方式ID
   */
  learningId: string
  /**
   * 每日一卷
   */
  dailyExamination: DailyExaminationResponse
  /**
   * 易错题
   */
  errorPronePractice: ErrorPronePracticeResponse
  /**
   * 试题练习
   */
  questionPractice: QuestionPracticeLearningResponse

  /**
   * 是否开放“每日一练”
   */
  isOpenDaily() {
    if (this.dailyExamination) {
      return true
    } else {
      return false
    }
  }

  /**
   * 是否开放易错题
   */
  isOpenErrorProne() {
    if (this.errorPronePractice) {
      return true
    } else {
      return false
    }
  }

  /**
   * 是否开放“试题练习”
   */
  isOpenPractice() {
    if (this.questionPractice?.openPractice) {
      return true
    } else {
      return false
    }
  }

  /**
   * 是否开放“真题试题”
   */
  isOpenRealPractice() {
    if (this.questionPractice?.openReal) {
      return true
    } else {
      return false
    }
  }

  /**
   * 是否开放“模拟考试”
   */
  isOpenSimulation() {
    if (this.questionPractice?.openSimulation) {
      return true
    } else {
      return false
    }
  }
}
// 包含期数和有效期
export class UserIssueUi {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期数ID（期数）
   */
  issueId: string
  /**
   * 课程学习方式编号
   */
  learningId: string

  /**
   * 商品SkuId
   */
  newEffectiveCommoditySkuId: string
  /**
   * 补考商品sku
   */
  resitEffectiveCommoditySkuId: string
  /**
   * 有效期天数
   */
  validDay: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price: number
  /**
   * 上下架设置
   */
  upDownSettings: UpDownSettingsResponse

  /**
   * 培训方案名称
   */
  schemeName: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm: string
  /**
   * 课程学习方式信息
   */
  courseLearning: CourseLearningResponse
  /**
   * 考试学习方式信息
   */
  examLearning: ExamLearningResponse

  /**
   * 所属行业编号
   */
  industryId: string
  /**
   * 所属专业编号
   */
  majorId: string
  /**
   * 练习学习方式
   */
  practiceLearning: PracticeLearningUi
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 期别有效
   */
  // effetiveness: Effectiveness
  /**
   * 所属考纲
   */
  syllabusId: string
  /**
   * 呈现结构 考纲结构：syllabus 非考纲结：：negateSyllabus
   */
  presentationStructure: string
  /**
   * 是否包含考试学习方式
   */
  hasExamLearning() {
    return !!this.examLearning?.learningId
  }

  /**
   * 是否包含练习学习方式
   */
  hasPracticeLearning() {
    return !!this.practiceLearning?.learningId
  }

  /**
   * 是否开放课程学习
   */
  hasCourseStudy() {
    return !!this.learningId
  }

  /**
   * 是否开放每日一练
   */
  isOpenDaily() {
    return !!this.practiceLearning?.dailyExamination?.enabled
  }

  /**
   * 是否开放易错题
   */
  isOpenErrorProne() {
    return !!this.practiceLearning?.errorPronePractice?.enabled
  }

  /**
   * 是否开放试题练习
   */
  isOpenQuestionPractice() {
    return !!this.practiceLearning?.questionPractice.enabled
  }

  /**
   * 是否开放模拟试题练习
   */
  isOpenSimulation() {
    return !!this.practiceLearning?.questionPractice?.openSimulation
  }
}
